<!-- Footer -->
<footer>
    <div class="top-footer bg-main-color py-4">

        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="categories">
                        <h5 class="text-uppercase text-secondary-color">categories</h5>
                        <ul class="list-style-none p-0">
                            <li class="py-2"><a href="#" class="text-white text-uppercase">carpet</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">hardwood flooring</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green wood</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">tile</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">venial</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green flooring</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="categories">
                        <h5 class="text-uppercase text-secondary-color">information</h5>
                        <ul class="list-style-none p-0">
                            <li class="py-2"><a href="#" class="text-white text-uppercase">carpet</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">hardwood flooring</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green wood</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">tile</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">venial</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green flooring</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="categories">
                        <h5 class="text-uppercase text-secondary-color">my account</h5>
                        <ul class="list-style-none p-0">
                            <li class="py-2"><a href="#" class="text-white text-uppercase">carpet</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">hardwood flooring</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green wood</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">tile</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">venial</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green flooring</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="categories">
                        <h5 class="text-uppercase text-secondary-color">get involved</h5>
                        <ul class="list-style-none p-0">
                            <li class="py-2"><a href="#" class="text-white text-uppercase">carpet</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">hardwood flooring</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green wood</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">tile</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">venial</a></li>
                            <li class="py-2"><a href="#" class="text-white text-uppercase">green flooring</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-footer bg-secondary-color py-4">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <ul class="list-style-none p-0 mb-0">
                        <li class="d-inline-block bg-white"><span class="d-inline-block bg-primary shadow-sm"> <a href="#" class="text-white"><i class="fab fa-facebook-f"></i></a></span> </li>
                        <li class="d-inline-block bg-white"><span class="d-inline-block shadow-sm bg-secondary-color"> <a href="#" class="text-white"><i class="fab fa-twitter"></i></a> </span></li>
                        <li class="d-inline-block bg-white"><span class="d-inline-block shadow-sm bg-danger"> <a href="#" class="text-white"><i class="fab fa-google"></i></a></span></li>
                    </ul>
                </div>
                <div class="col-lg-6">
                    <p class="text-capitalize mb-0 text-white">&copy; 2014 company all software by rights reserved</p>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- ./Footer -->